import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import Loading from "../../components/Loading";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

import { useTranslation } from "react-i18next";

const Title = ({ classes, addressName, title }) => (
	<FormLabel className={classes.formLegend} component="legend">
		<Typography className={classes.titleText} variant="h3">
			{title}
		</Typography>
	</FormLabel>
);

const PayCard = (props) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const isMin600 = useMediaQuery("(max-width: 599px)");
	const isMax600 = useMediaQuery("(min-width: 600px)");
	let addressName;

	if (!props.shops) {
		return null;
	}

	return (
		<Grid container>
			<Grid item xs={12}>
				{isMin600 && (
					<Typography className={classes.titleMobile} variant="h3">
						{t("cardPayments.paymentSystems")}
					</Typography>
				)}
				<Paper className={classes.paper}>
					{isMax600 && (
						<Title
							classes={classes}
							title={t("cardPayments.paymentSystems")}
							addressName={addressName}
						/>
					)}
					{props.shops ? (
						<FormGroup>
							{/* Основная карта */}
							{!props.payCardForDeliveryPickup && (
								<FormControlLabel
									className={classes.FormControlLabel}
									control={
										<Switch
											className={classes.checked}
											checked={props.statusPayment}
											onChange={props.updateStatusApp}
											color="primary"
										/>
									}
									label={t("cardPayments.card")}
								/>
							)}
							{props.payCardForDeliveryPickup && (
								<>
									{/* Онлайн для доставки */}
									<FormControlLabel
										className={classes.FormControlLabel}
										control={
											<Switch
												className={classes.checked}
												checked={props.statusDelivery}
												onChange={props.updateStatusDelivery}
												color="primary"
											/>
										}
										label={t("cardPayments.cardOnlineDelivery")}
									/>

									{/* Онлайн для самовывоза */}
									<FormControlLabel
										className={classes.FormControlLabel}
										control={
											<Switch
												className={classes.checked}
												checked={props.statusPickup}
												onChange={props.updateStatusPickup}
												color="primary"
											/>
										}
										label={t("cardPayments.cardOnlinePickup")}
									/>
								</>
							)}
							{console.log("props.statusCash", props.statusCash)}
							<FormControlLabel
								className={classes.FormControlLabel}
								control={
									<Switch
										className={classes.checked}
										checked={props.statusCash}
										onChange={props.updateStatusCash}
										color="primary"
									/>
								}
								label={t("cardPayments.cash")}
							/>
						</FormGroup>
					) : (
						<Loading size={22} color={"#326dff"} />
					)}
				</Paper>
			</Grid>
		</Grid>
	);
};

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: theme.spacing(2),
		paddingTop: 24,
		paddingBottom: 16,
	},
	titleText: {
		fontFamily: "Roboto",
		fontSize: 22,
		lineHeight: 1,
		fontWeight: "bold",
		color: "black",
		letterSpacing: "0.003em",
	},
	titleMobile: {
		marginTop: 12,
		marginBottom: 8,
		fontFamily: "Roboto",
		fontSize: 22,
		lineHeight: 1,
		fontWeight: "bold",
		color: "black",
		letterSpacing: "0.003em",
	},
	formLegend: {
		display: "flex",
		marginBottom: 12,
	},
	checked: {
		[theme.breakpoints.down("600")]: {
			order: 1,
		},
		"& .Mui-checked .MuiSwitch-thumb": {
			color: "#326DFF",
		},
		"& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track": {
			backgroundColor: "#326DFF",
		},
	},
	FormControlLabel: {
		display: "flex",
		maxWidth: 300,
		fontSize: 14,
		lineHeight: "16px",
		color: "#476282",
		letterSpacing: "0.003em",
		[theme.breakpoints.down("600")]: {
			paddingLeft: 10,
		},
	},
}));

export default PayCard;
